/**
 * @fileoverview Hook for managing session storage
 *
 * @example
 * // Usage:
 * import { useSessionStorage } from './useSessionStorage'
 *
 * function Component() {
 *   const sessionStorage = useSessionStorage()
 *   // ...
 * }
 */

/**
 * @function useSessionStorage
 * @description Hook for managing session storage
 * @returns {object} An object containing two functions:
 * - `set<T>(key: string, value: T)`: Sets a value in session storage
 * - `get<T>(key: string)`: Gets a value from session storage
 */
export function useSessionStorage() {
    function set<T>(key: string, value: T) {
        sessionStorage.setItem(key, JSON.stringify(value))
    }

    function get<T>(key: string): T | undefined {
        try {
            return JSON.parse(sessionStorage.getItem(key))
        } catch (e: unknown) {
            return undefined
        }
    }

    return { get, set }
}
